export default class Ribbon {
	constructor(cells) {
		this.cells = cells;
		this.images = [];
		this.classes = [];
	}

	addImage(img) {
		this.images.push(img);
		for (const className of this.classes)
			img.classList.add(className);
	}

	get size() {
		return this.images.length;
	}

	setClass(...classes) {
		for (const img of this.images)
			for (const className of this.classes)
				img.classList.remove(className);
		this.classes = classes;
		for (const img of this.images)
			for (const className of this.classes)
				img.classList.add(className);
	}

	includesTile(tx, ty) {
		return this.cells.some(cell => cell.x == tx && cell.y == ty);
	}

	similarity(other) {
		let s = 0;
		for (const { x, y } of this.cells) if (other.includesTile(x, y)) ++s;
		return s;
	}

	mostSimilar(others) {
		let mss = 0, ms = null;
		for (const other of others) {
			const s = this.similarity(other);
			if (s > mss) { mss = s; ms = other; }
		}
		return ms;
	}

	// true if:
	//  * every bead on this ribbon is the same colour, AND
	//  * every bead of that colour is on this ribbon
	isComplete(beads) {
		const coloursOnRibbon = new Set(), coloursOffRibbon = new Set();
		for (const { x, y, colour } of beads) {
			if (this.includesTile(x, y)) coloursOnRibbon.add(colour);
			else coloursOffRibbon.add(colour);
		}
		if (coloursOnRibbon.size != 1) return { complete: false };
		const [colour] = coloursOnRibbon;
		return { complete: !coloursOffRibbon.has(colour), colour };
	}

	highlightBy(x, y) {
		// this is horrible code but it works so just collapse this function in your ide and don't think about it
		if (x === undefined) {
			for (const img of this.images) {
				img.classList.remove("highlight-off");
				img.classList.remove("highlight-on");
				img.classList.remove("highlight-close");
			}
			return;
		}
		if (!this.includesTile(x, y)) {
			for (const img of this.images) {
				img.classList.add("highlight-off");
				img.classList.remove("highlight-on");
				img.classList.remove("highlight-close");
			}
			return;
		}
		for (const img of this.images) {
			img.classList.remove("highlight-off");
			img.classList.add("highlight-on");
			img.classList.remove("highlight-close");
		}
		// TODO: get this array in order so taht highlighting words???
		const start = mainImageIn(cellAt(x, y));
		const doneImages = new Set([start]);
		const move = (img, direction) => {
			let { x, y } = img.parentElement.parentElement.dataset;
			x = parseInt(x, 10); y = parseInt(y, 10);
			// 1 2 3
			// 4 * 6
			// 7 8 9
			switch (direction) {
				case "1": return [
					mainImageIn(cellAt(x - 1, y - 1)),
					diagCornerIn(cellAt(x - 1, y), "d1x"),
					diagCornerIn(cellAt(x, y - 1), "d1y")
				];
				case "2": return [mainImageIn(cellAt(x, y - 1))];
				case "3": return [
					mainImageIn(cellAt(x + 1, y - 1)),
					diagCornerIn(cellAt(x + 1, y), "d3x"),
					diagCornerIn(cellAt(x, y - 1), "d3y")
				];
				case "4": return [mainImageIn(cellAt(x - 1, y))];
				case "6": return [mainImageIn(cellAt(x + 1, y))];
				case "7": return [
					mainImageIn(cellAt(x - 1, y + 1)),
					diagCornerIn(cellAt(x - 1, y), "d3y"),
					diagCornerIn(cellAt(x, y + 1), "d3x")
				];
				case "8": return [mainImageIn(cellAt(x, y + 1))];
				case "9": return [
					mainImageIn(cellAt(x + 1, y + 1)),
					diagCornerIn(cellAt(x + 1, y), "d1y"),
					diagCornerIn(cellAt(x, y + 1), "d1x")
				];
				default: throw new Error("unexpected direction");
			}
		}
		start.classList.add("highlight-close");
		const startDirections = [...start.classList].find(x => x.startsWith("img-")).substring(4).split('-');
		for (const sd of startDirections) {
			let [c, ...corners] = move(start, sd);
			for (const corner of corners) corner.classList.add("highlight-close");
			for (let i = 0; i < 10; ++i) {
				c.classList.add("highlight-close");
				doneImages.add(c);
				const directions = [...c.classList].find(x => x.startsWith("img-")).substring(4).split('-');
				for (const d of directions) {
					const [next, ...corners] = move(c, d);
					if (doneImages.has(next)) continue;
					for (const corner of corners) corner.classList.add("highlight-close");
					c = next;
					break;
				}
			}
		}
	}
}

function cellAt(x, y) {
	// TODO: this is hacky but ok for now
	const c = document.querySelector(`[data-x="${x}"][data-y="${y}"] .ribbon-images`);
	if (!c) throw new Error("Missing cell");
	return c;
}

function diagCornerIn(cell, className) {
	const c = cell.querySelector(`div.img-${className}`);
	if (!c) throw new Error("Missing corner");
	return c;
}

function mainImageIn(cell) {
	const i = cell.querySelector(
		"div:not(.img-d1x):not(.img-d1y):not(.img-d3x):not(.img-d3y)"
	);
	if (!i) throw new Error("Missing image");
	return i;
}
